import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "../locales/en/translation.json";
import fr from "../locales/fr/translation.json";
import enMarket from "../locales/en/market.json";
import enMultiSelect from "../locales/en/multiSelect.json";
import enStoreStatusHexGrid from "../locales/en/storeStatusHexGrid.json";
import enStoreMainServices from "../locales/en/StoreMainServices.json";
import enStoreStatusDetails from "../locales/en/storeStatusDetails.json";
import enServiceDetails from "../locales/en/storeServiceDetails.json";

import frMarket from "../locales/fr/market.json";
import frMultiSelect from "../locales/fr/multiSelect.json";
import frStoreStatusHexGrid from "../locales/fr/storeStatusHexGrid.json";
import frStoreMainServices from "../locales/fr/StoreMainServices.json";
import frStoreStatusDetails from "../locales/fr/storeStatusDetails.json";
import frServiceDetails from "../locales/fr/storeServiceDetails.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      market: enMarket,
      multiSelect: enMultiSelect,
      storeStatusHexGrid: enStoreStatusHexGrid,
      storeMainServices: enStoreMainServices,
      storeStatusDetails: enStoreStatusDetails,
      storeServiceDetails: enServiceDetails,
    },
    fr: {
      market: frMarket,
      multiSelect: frMultiSelect,
      storeStatusHexGrid: frStoreStatusHexGrid,
      storeMainServices: frStoreMainServices,
       storeStatusDetails: frStoreStatusDetails,
      storeServiceDetails: frServiceDetails,
    },
  },
  lng: "en",
  fallbackLng: "en",
  ns: ["market", "multiSelect", "storeStatusHexGrid", "storeMainServices","storeStatusDetails","storeServiceDetails"],
  interpolation: { escapeValue: false },
});

export default i18n;
